import React, { useEffect, useRef } from 'react';
import './index.scss';
import { getLeftArrowImage } from '../../utils/imageChanges';
import PreMealImage from './PreMealImage';
import Icon from './Icon';
import { FooterButton } from './molecules';
import usePrebookInfo from '../../hooks/usePrebookInfo';

export const PrebookModalHeader = ({ onGoBack, title }) => {
  const handleGoBack = () => {
    if (typeof onGoBack === 'function') {
      onGoBack();
    }
  };

  return (
    <div className="avengers__header">
      <button
        type="button"
        className="avengers__back-icon"
        onClick={handleGoBack}
      >
        <img src={getLeftArrowImage()} alt="Back" />
      </button>
      <h1 className="avengers__header-title">{title}</h1>
    </div>
  );
};

const AvengersDoomsday = ({ onGoBack, item, onPreBook }) => {
  const { preBook } = usePrebookInfo();
  const addToCartRef = useRef(null);

  const handlePreBook = () => {
    if (typeof onPreBook === 'function') {
      onPreBook(true, item, false, [], 'normal');
    }
  };

  useEffect(() => {
    const button = addToCartRef.current;

    if (button && typeof button.focus === 'function') {
      button.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      button.focus({ preventScroll: true });
    }
  }, []);

  return (
    <div className="avengers">
      <PrebookModalHeader onGoBack={onGoBack} title="Avengers Doomsday Meal" />
      <div className="avengers__outer-wrapper">
        <PreMealImage
          className="avengers__banner"
          imageUrls={item?.image_urls}
          category="hpiv"
          alt={item?.name}
        />
        <div className="avengers__wrapper">
          <p className="avengers__offer-title">LIMITED-TIME MEAL</p>
          <h1 className="avengers__meal-title">{item?.name}</h1>
          <p className="avengers__meal-description">
            {item?.description ||
              'A guaranteed meal for the day Doomsday arrives.'}
          </p>

          <div className="avengers__price-con">
            <span className="title">One guaranteed meal</span>
            <span className="price-con">
              {item?.variant?.price && item?.variant?.actual_price && (
                <span className="price slash">
                  ₹ {item?.variant?.actual_price}/-
                </span>
              )}
              <span className="price">
                ₹ {item?.variant?.price || item?.variant?.actual_price}/-
              </span>
            </span>
          </div>
          <div className="avengers__info-con">
            <div className="icon-con">
              <Icon name="info" className="icon" />
            </div>
            <div className="info-con">
              <p className="title">Before you pre-book</p>
              <ul className="list-description-con">
                <li className="description">Dine-in redemption only.</li>
                <li className="description">
                  Can be redeemed at any Burger King restaurant.
                </li>
                <li className="description">
                  Available to redeem from {preBook?.unLocksAt}.
                </li>
                <li className="description">
                  Limited to one pre-book per account.
                </li>
                <li className="description">
                  Valid until {preBook?.redeemUntil}, subject to application
                  terms apply.
                </li>
                <li className="description">Refund terms apply.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <FooterButton ref={addToCartRef} onClick={handlePreBook}>
        Pre-book now
      </FooterButton>
    </div>
  );
};

export default AvengersDoomsday;
